<template lang="pug">
.re-forgot-password.gmh-forgot-password(:class="classes")
    .re-forgot-password-box
        .re-container-form
            .re-form-head
                h2.box-form-title(v-if="showTitle") {{ title }}
                p.box-form-head-message(v-if="showSubTitle") {{ subTitle }}
                p.box-form-head-error(v-if="!!formErrorMessage" v-html="formErrorMessage")
            .re-form-body
                .re-inp-box.re-inp-box--with-icon
                    re-input(
                        v-model.trim="$v.fields.email.$model"
                        v-bind="getFieldProps('email', {type: 'email', defaults: {label: 'Email'}})"
                    )
                    .re-inp-box__icon
                        img(:src="`${baseUri}/images/client/lairdnd/input-icon-envelope.svg`")

                .re-submit-button-container
                    re-button.btn-primary.btn-lg.re-submit-button(@click="requestResetLink" :classes="submitButtonClasses") {{ submitButtonTitle }}

    re-modal.reset-password-modal(v-if="modal" container-class="re-modal-sm" @close="hideModal")
        img(:src="`${baseUri}/images/client/lairdnd/forgot-password.jpg`" alt="")
        .re-modal-title.mt-3 {{ successTitle }}
        .re-modal-content
            p.reset-password-request-success-message(v-if="isResendEmail") {{ resendMessage }}
            p.reset-password-request-success-message(v-else) {{ successMessage }}
            re-button.btn-primary.btn-lg.resend-button.mt-2(@click="resend" :loading="sendingResetRequest") Resend

</template>

<script>
import ReForgotPassword from 'utils/vue/components/complex/user/re-forgot-password/script.js'

export default {
    name: 'lairdnd-forgot-password',
    mixins: [
        ReForgotPassword,
    ],
    data() {
        return {
            modal: false,
        }
    },
    watch: {
        resetRequestSent(val) {
            if (val) {
                this.modal = true
            }
        }
    },
    methods: {
        hideModal() {
            this.modal = false
            this.resetForm()
        },
    }
}
</script>
